import { Component, Input } from '@angular/core';
import { BaseComponent } from '../base.component';
import { SaveStatus } from './save-status.enum';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
    selector: 'nha-save-status',
    templateUrl: './save-status.component.html',
    styleUrls: ['./save-status.component.scss'],
    imports: [MatProgressSpinnerModule, MatIconModule]
})
export class NHASaveStatusComponent extends BaseComponent {
	@Input() saveStatus: SaveStatus;
}
